import { getElement, getElements } from '../helpers/functions';
import SlideMenu from '../vendors/menu/SlideMenu';
import { baseElements, breakpoints } from '../helpers/constants';
import { getScroll } from './smooth-scroll';
const {
  $header
} = baseElements;
export default class MobileNavigation {
  constructor() {
    this.element = getElement('#slide-menu');
    if (!this.element) return;
    this.menu = null;
    this.lenis = getScroll();
    this.toggleBtn = getElement('.slide-menu__toggle', $header);
    this.backLinkTitle = this.element.dataset.backLinkTitle;
    this.languageBtn = getElements('[data-panel="#language-panel"]');
    this.init();
  }
  init() {
    this.initEventHandlers();
  }
  initEventHandlers() {
    document.addEventListener('click', e => {
      if (e.target.matches('body') && this.menu) this.menu.close();
    });
    this.toggleBtn.addEventListener('click', () => {
      if (this.menu !== null) this.menu.toggle();
    });
    this.element.addEventListener('sm.open', () => {
      this.toggleBtn.classList.add('__close');
      $header.classList.add('_up', '_sticky');
      $header.classList.remove('_down');
      $header.style.transform = 'translate3d(0, 0, 0)';
    });
    this.element.addEventListener('sm.close', () => {
      this.toggleBtn.classList.remove('__close');
    });
    this.element.addEventListener('sm.forward', e => {
      e.target.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    this.languageBtn.forEach($btn => {
      $btn.addEventListener('click', () => {
        if (window.innerWidth < breakpoints.xl) {
          this.menu.open();
          this.menu.navigateTo('.slide-menu__link-region');
        }
      });
    });
  }
  create() {
    if (this.menu !== null) return;
    this.menu = new SlideMenu(this.element, {
      position: 'left',
      saveMenuState: false,
      showTitle: false,
      backLinkTitle: 'current',
      backLinkBefore: '<span class="icon icon-chevron_left"></span>',
      submenuLinkAfter: '<span class="icon icon-chevron_right"></span>',
      onOpen: () => this.lenis.stop(),
      onClose: () => this.lenis.start()
    });
  }
  destroy() {
    if (this.menu == null) return;
    this.menu.destroy();
    this.menu = null;
  }
}